import CourseDetailsSection from './CourseDetailsSection';
import { CourseDetailsSectionProps, CourseDetailsSectionValueProps } from './types';

export type { CourseDetailsSectionProps, CourseDetailsSectionValueProps };
export default CourseDetailsSection;
